import TimeInQueue from './TimeInQueue';

const STATUS_COLORS = { Open: '#3b82f6', Claimed: '#f59e0b', Resolved: '#10b981' };

export default function CallCard({ call, user, can, canInModule, onClaim, onUnclaim, onResolve, onEdit, onDelete, onClick }) {
  const isDriver = (user.team_name || '') === 'Driver Operations' || user.role === 'driver';
  const isMyClaim = call.claimed_by === user.id;
  const canUnclaim = call.status === 'Claimed' && (isMyClaim || !isDriver);

  // Check if call has a due_time that hasn't arrived yet (resolve blocked)
  const isDueTimePending = call.due_time && new Date(call.due_time.replace(' ', 'T') + 'Z').getTime() > Date.now();
  const dueTimeDisplay = call.due_time
    ? new Date(call.due_time.replace(' ', 'T') + 'Z').toLocaleTimeString('en-US', { timeZone: 'America/Chicago', hour: 'numeric', minute: '2-digit' })
    : null;

  const isEmergency = !!call.is_emergency;

  return (
    <div className={`call-card status-${call.status.toLowerCase()}${isEmergency ? ' emergency' : ''}`} onClick={onClick}>
      <div className="call-card-header">
        <div className="call-card-left">
          <span className="status-badge" style={{ background: STATUS_COLORS[call.status] }}>{call.status}</span>
          {isEmergency && <span className="emergency-badge">EMERGENCY</span>}
        </div>
        <TimeInQueue createdAt={call.due_time || call.created_at} />
      </div>

      <div className="call-card-body">
        <div className="call-property">{call.property_name || call.call_type_name || 'Unknown'}</div>
        <div className="call-location">{call.location}</div>
        {call.call_type_name && <div className="call-type-badge">{call.call_type_name}</div>}
        {call.source_type === 'request' && call.source_id && (
          <a
            href={`/sales/requests/take_back/${call.source_id}`}
            onClick={e => e.stopPropagation()}
            style={{
              display: 'inline-block', marginTop: 4, padding: '2px 10px', borderRadius: 4,
              background: '#ede9fe', color: '#6d28d9', fontWeight: 700, fontSize: 11,
              textDecoration: 'none', letterSpacing: 0.3,
            }}
          >
            ↩️ From Take Back #{call.source_id}
          </a>
        )}
        {call.space_number && <div className="call-space">Space #{call.space_number}</div>}
        {dueTimeDisplay && <div className="call-due-time">Due at {dueTimeDisplay} CT</div>}
        {call.claimed_by_name && <div className="call-claimed">Claimed: <strong>{call.claimed_by_name}</strong></div>}
        {call.comment_count > 0 && (
          <div className="call-comment-badge">💬 {call.comment_count}</div>
        )}
      </div>

      <div className="call-card-actions" onClick={e => e.stopPropagation()}>
        {call.status === 'Open' && can('claim_calls') && (
          <button className="btn btn-primary btn-sm" onClick={() => onClaim(call.id)}>Claim</button>
        )}
        {((call.status === 'Claimed' && (isMyClaim || can('resolve_calls'))) ||
          (call.status === 'Open' && !isDriver && can('resolve_calls'))) && (
          isDueTimePending
            ? <button className="btn btn-sm btn-muted" disabled title={`Cannot resolve before due time (${dueTimeDisplay} CT)`}>Due at {dueTimeDisplay}</button>
            : <button className="btn btn-success btn-sm" onClick={() => onResolve(call)}>Resolve</button>
        )}
        {canUnclaim && (
          <button className="btn btn-sm btn-muted" onClick={() => onUnclaim(call.id)}>Unclaim</button>
        )}
        {(canInModule ? canInModule('dispatch', 'edit_calls') : can('edit_calls')) && call.status !== 'Resolved' && (
          <button className="btn btn-sm btn-muted" onClick={() => onEdit(call)}>Edit</button>
        )}
        {can('delete_calls') && (
          <button className="btn btn-sm btn-danger" onClick={() => onDelete(call.id)}>Delete</button>
        )}
      </div>
    </div>
  );
}
